/**
 * Commercial Lines Rating — setup gate API service.
 * Mirrors personalLineRatingService.ts for the WC MCP setup flow.
 */

const ACCOUNT_AMP_BASE =
  process.env.REACT_APP_Auth_Url || 'https://momentumampapi-stage.insurancegig.com';

const CLR_BASE = `${ACCOUNT_AMP_BASE}/api/CommercialLineRating`;

export interface CommercialLineRatingStatus {
  isEnabled: boolean;
  isMcpConfigured: boolean;
}

export async function getCommercialLineRatingStatus(): Promise<CommercialLineRatingStatus> {
  const authToken = localStorage.getItem('authToken') || '';
  const res = await fetch(`${CLR_BASE}/status`, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  if (!res.ok) throw new Error(`CLR status check failed (${res.status})`);
  return res.json();
}

export interface EnableCommercialLineRatingResult {
  success: boolean;
  message: string;
  code?: string;
}

export async function enableCommercialLineRating(
  rateJwt: string,
): Promise<EnableCommercialLineRatingResult> {
  const authToken = localStorage.getItem('authToken') || '';
  const res = await fetch(`${CLR_BASE}/enable`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify({ rateJwt }),
  });
  if (!res.ok) throw new Error(`CLR enable failed (${res.status})`);
  return res.json();
}
